import ResponsiveMenu from './ResponsiveMenu';

export default ResponsiveMenu;
